module.exports = __webpack_public_path__ + "img/flag.b3f5ae10.svg";